import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import uniq from 'lodash/uniq';
import {
  selectedIndicator as indicator,
  surveys as allSurveys,
  setSelectedIndicator,
  setSelectedSurvey,
} from '../../store/slices/modelSurfaceSlice';
import store from '../../store/store';

export default function IndicatorDropDown() {
  const selectedIndicator = useSelector(indicator);
  const surveys = useSelector(allSurveys);
  const [indicatorList, setIndicatorList] = useState([]);

  useEffect(() => {
    if (Object.keys(surveys).length) {
      store.dispatch(setSelectedIndicator({ Label: 'all_indicators' }));
      //Get the lable of all the indicators
      let allIndicators: any = surveys.map((survey) =>
        survey.indicators.map((indicator) => {
          return { Label: indicator.Label, IndicatorOrder: indicator.IndicatorOrder };
        })
      );
      allIndicators = allIndicators.flat(); //flatten array
      allIndicators = allIndicators.sort((a, b) => a.IndicatorOrder - b.IndicatorOrder); // sort based on Indicator Order
      allIndicators = allIndicators.map((obj) => obj.Label); //map Out only the Labels
      allIndicators = uniq(allIndicators); //remove duplicates
      allIndicators = allIndicators.filter((indicator) => indicator); // remove undefined
      setIndicatorList(allIndicators);
    }
  }, [surveys]);

  function handleIndicatorChange(e) {
    if (e.target.value === 'all_indicators') {
      store.dispatch(setSelectedIndicator({ Label: 'all_indicators' }));
      store.dispatch(setSelectedSurvey({ name: 'all_countries' }));
      return;
    }
    let indicatorObj = surveys
      .find((survey) => survey.indicators.findIndex((indicator) => indicator.Label === e.target.value) !== -1)
      .indicators.find((indicator) => indicator.Label === e.target.value);

    store.dispatch(setSelectedIndicator(indicatorObj));
    store.dispatch(setSelectedSurvey({ name: 'all_countries' }));
  }

  return (
    <div>
      <label className='country-label'>Select Indicator</label>
      <div className='slate styled-select'>
        <select
          className='selection'
          value={selectedIndicator.Label}
          onChange={handleIndicatorChange}
          style={{ paddingRight: '3em', overflow: 'hidden', textOverflow: 'ellipsis' }}
        >
          <option value='all_indicators'>All Indicators</option>
          {indicatorList.map((indicator, i) => {
            return (
              <option value={indicator} key={`${indicator}_${i}`}>
                {indicator}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
}
